/* THE LONG VIEW: draws site/longview.json (built by alert-digest/longview.py).
   A few big, slow numbers about forests, water and lumber, each beside its own history.
   Every figure and its source come from the data file; nothing is computed here except
   the change over the range a reader picks on the lumber chart. */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function svg(tag, attrs, text) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (text != null) n.textContent = text;
    return n;
  }
  function fmt(v, d) {
    return v.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
  }

  // ---- bars: one per period, value on top, label underneath; estimates are pale and dashed
  function bars(p) {
    var W = 360, H = 190, top = 20, base = 148, n = p.bars.length;
    var max = Math.max.apply(null, p.bars.map(function (b) { return b.v; }));
    var slot = W / n, bw = Math.min(46, slot * 0.66);
    var s = svg('svg', { viewBox: '0 0 ' + W + ' ' + H, role: 'img', 'aria-label': p.q });
    s.appendChild(svg('line', { x1: 0, x2: W, y1: base + 0.75, y2: base + 0.75, 'class': 'lv-axis' }));
    p.bars.forEach(function (b, i) {
      var cx = slot * (i + 0.5), h = Math.max(2, (b.v / max) * (base - top));
      s.appendChild(svg('rect', { x: cx - bw / 2, y: base - h, width: bw, height: h, 'class': 'lv-bar' + (b.est ? ' lv-est' : '') }));
      s.appendChild(svg('text', { x: cx, y: base - h - 5, 'class': 'lv-val' }, fmt(b.v, p.decimals)));
      var words = b.label.split(' '), lines = [b.label];
      if (b.label.length > 9 && words.length > 1) {          // "10,000 years ago" -> two lines
        var cut = Math.ceil(words.length / 2);
        lines = [words.slice(0, cut).join(' '), words.slice(cut).join(' ')];
      }
      lines.forEach(function (t, k) { s.appendChild(svg('text', { x: cx, y: base + 14 + k * 11, 'class': 'lv-lab' }, t)); });
    });
    return s;
  }

  // ---- line: a year (or month) series from zero, with the first, last, low and high marked
  function line(p, pts) {
    var W = p.wide ? 760 : 360, H = p.wide ? 230 : 190, L = 4, R = 44, top = 16, base = H - 30;
    var x0 = pts[0][0], x1 = pts[pts.length - 1][0];
    var max = Math.max.apply(null, pts.map(function (q) { return q[1]; })) * 1.06;
    function X(x) { return L + (x1 === x0 ? 0 : (x - x0) / (x1 - x0)) * (W - L - R); }
    function Y(v) { return base - (v / max) * (base - top); }
    var s = svg('svg', { viewBox: '0 0 ' + W + ' ' + H, role: 'img', 'aria-label': p.q });
    var path = pts.map(function (q) { return X(q[0]).toFixed(1) + ',' + Y(q[1]).toFixed(1); });
    s.appendChild(svg('polygon', { points: L + ',' + base + ' ' + path.join(' ') + ' ' + X(x1).toFixed(1) + ',' + base, 'class': 'lv-area' }));
    s.appendChild(svg('line', { x1: 0, x2: W, y1: base + 0.75, y2: base + 0.75, 'class': 'lv-axis' }));
    s.appendChild(svg('polyline', { points: path.join(' '), 'class': 'lv-line' }));
    var last = pts[pts.length - 1], hi = pts.reduce(function (a, b) { return b[1] > a[1] ? b : a; });
    s.appendChild(svg('circle', { cx: X(last[0]), cy: Y(last[1]), r: 3.5, 'class': 'lv-dot' }));
    s.appendChild(svg('text', { x: X(last[0]) + 7, y: Y(last[1]) + 4, 'class': 'lv-val', style: 'text-anchor:start' }, fmt(last[1], p.decimals)));
    if (hi !== last && X(last[0]) - X(hi[0]) > 40) {
      s.appendChild(svg('circle', { cx: X(hi[0]), cy: Y(hi[1]), r: 2.5, 'class': 'lv-dot' }));
      s.appendChild(svg('text', { x: X(hi[0]), y: Y(hi[1]) - 6, 'class': 'lv-val' }, fmt(hi[1], p.decimals)));
    }
    var span = x1 - x0, step = span > 60 ? 25 : span > 30 ? 10 : span > 12 ? 5 : span > 6 ? 2 : 1;
    for (var t = Math.ceil(x0 / step) * step; t <= x1; t += step) {
      if (X(t) < 14 || X(t) > W - R - 6) continue;
      s.appendChild(svg('text', { x: X(t), y: base + 15, 'class': 'lv-tick', style: 'text-anchor:middle' }, String(t)));
    }
    s.appendChild(svg('text', { x: L, y: base + 15, 'class': 'lv-tick' }, String(Math.floor(x0))));
    return s;
  }

  // the tag's weight follows how much the number can carry: solid, outlined, dashed
  var WEIGHT = { 'Measured': 'solid', 'Reported': 'line' };
  function tag(grade) {
    return el('span', 'lv-grade lv-' + (WEIGHT[grade] || 'dash'), grade);
  }

  function panel(p) {
    var box = el('div', 'lv-panel' + (p.wide ? ' lv-wide' : ''));
    var top = el('div', 'lv-top');
    top.appendChild(el('span', 'lv-q', p.q));
    top.appendChild(tag(p.grade));
    box.appendChild(top);
    var big = el('div', 'lv-big', p.big), sub = el('div', 'lv-sub', p.sub);
    box.appendChild(big); box.appendChild(sub);
    if (p.kind) {
      var holder = el('div', 'lv-chart');
      box.appendChild(holder);
      if (p.kind === 'bars') {
        holder.appendChild(bars(p));
        if (p.bars.some(function (b) { return b.est; })) {
          var key = el('div', 'lv-key');
          key.appendChild(el('span', null, p.grade)); key.appendChild(el('span', 'lv-est', "Historians' estimate"));
          box.appendChild(key);
        }
      } else if (p.ranges) {
        // lumber: the reader picks how far back to look, and the headline number follows
        var row = el('div', 'lv-ranges'), lastX = p.pts[p.pts.length - 1][0];
        var show = function (i) {
          var years = p.ranges[i][1], pts = p.pts.filter(function (q) { return q[0] >= lastX - years - 0.001; });
          var chg = Math.round((pts[pts.length - 1][1] / pts[0][1] - 1) * 100);
          var ago = years === 1 ? 'a year ago' : years + ' years ago';
          big.textContent = Math.abs(chg) < 3 ? 'About the same as ' + ago
            : Math.abs(chg) + '% ' + (chg < 0 ? 'cheaper' : 'more expensive') + ' than ' + ago;
          sub.textContent = 'US wholesale lumber, after inflation. Latest month: ' + p.latest + '.';
          holder.textContent = ''; holder.appendChild(line(p, pts));
          Array.prototype.forEach.call(row.children, function (b, k) {
            b.classList.toggle('on', k === i); b.setAttribute('aria-pressed', k === i ? 'true' : 'false');
          });
        };
        p.ranges.forEach(function (r, i) {
          var b = el('button', 'wn-chip', r[0]); b.type = 'button';
          b.addEventListener('click', function () { show(i); });
          row.appendChild(b);
        });
        box.insertBefore(row, holder);
        show(p.default);
      } else {
        holder.appendChild(line(p, p.pts));
      }
      box.appendChild(el('div', 'lv-unit', p.unit));
    }
    if (p.note) box.appendChild(el('div', 'lv-note', p.note));
    // how the number was obtained and what it means, then where to check it
    var how = el('div', 'lv-how');
    how.appendChild(el('b', null, 'How we know. '));
    how.appendChild(document.createTextNode(p.how));
    box.appendChild(how);
    var src = el('div', 'lv-src', 'Source: ' + p.source + ' ');
    (p.links || []).forEach(function (l, i) {
      var a = el('a', null, l[0]);
      a.href = l[1]; a.target = '_blank'; a.rel = 'noopener';
      if (i) src.appendChild(document.createTextNode(' · '));
      src.appendChild(a);
    });
    box.appendChild(src);
    return box;
  }

  window.sxfLongview = function (root, data) {
    root.textContent = '';
    root.appendChild(el('p', 'lv-intro', 'Big numbers on long timescales. Each panel says how its number was obtained, ' +
      'how much weight it can take, and where to check it.'));
    if (data.grades) {
      var legend = el('div', 'lv-legend');
      legend.appendChild(el('div', 'lv-q', 'What the tags mean'));
      data.grades.forEach(function (g) {
        var row = el('div', 'lv-lrow');
        row.appendChild(tag(g[0])); row.appendChild(el('span', null, g[1]));
        legend.appendChild(row);
      });
      root.appendChild(legend);
    }
    var grid = el('div', 'lv-grid'), group = null;
    data.panels.forEach(function (p) {
      if (p.group && p.group !== group) { group = p.group; grid.appendChild(el('h3', 'lv-group', group)); }
      grid.appendChild(panel(p));
    });
    root.appendChild(grid);
  };
})();
